"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var _ = require("@antv/util");
var base_1 = require("./base");
var shape_1 = require("../util/shape");
function getFillAttrs(cfg) {
    var textAttrs = cfg.style;
    shape_1.setFillStyle(textAttrs, cfg);
    if (_.isNumber(cfg.size)) { // 如果设置了size，则text的字体大小由size决定
        textAttrs.fontSize = cfg.size;
    }
    return textAttrs;
}
var TextShapeFactory = base_1.registerShapeFactory('text', {
    defaultShapeType: 'text',
    getDefaultPoints: function (pointInfo) {
        return shape_1.splitPoints(pointInfo);
    },
});
base_1.registerShape('text', 'text', {
    draw: function (cfg, container) {
        var attrs = getFillAttrs(cfg);
        var shape = container.addShape('text', {
            attrs: tslib_1.__assign(tslib_1.__assign({}, attrs), { x: cfg.x, y: cfg.y, text: cfg.text }),
        });
        return shape;
    },
    getMarkerStyle: function (markerCfg) {
        var markerStyle = {
            symbol: 'circle',
            radius: 4.5,
        };
        shape_1.setFillStyle(markerStyle, markerCfg);
        return markerStyle;
    },
});
exports.default = TextShapeFactory;
//# sourceMappingURL=text.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2/lib/element/shape/text.js
// module id = 821
// module chunks = 37